<script lang="ts">
  import { fade } from 'svelte/transition';
  import type { Snippet } from 'svelte';

  import { useCoreStore } from '../state/use-core-state.svelte';

  let { children }: { children?: Snippet } = $props();
  let CS = useCoreStore();
</script>

{#if $CS.initialized}
  <div transition:fade|global={{ duration: 400 }}>
    {@render children?.()}
  </div>
{/if}
